import Vue from "vue";
import App from "./App.vue";
import "vant/lib/index.css";
import Vant from "vant";
Vue.use(Vant);
import dayjs from "dayjs";
Vue.prototype.$dayjs = dayjs

import router from "./router/index";

import store from "./store/index";

import "./core/index";
import "./style/index.css";

import request from './utils/request'
Vue.prototype.$http = request

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
